'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialTwitterOutline = function IoSocialTwitterOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.4 8.6c-1 1.6-2.3 2.8-3.8 3.9v0.9c0 10-7.6 21.6-21.5 21.6-4.3 0-8.2-1.2-11.6-3.4 0.6 0 1.2 0.1 1.8 0.1 3.5 0 6.8-1.2 9.4-3.3-3.3 0-6.1-2.2-7.1-5.2 0.5 0.1 1 0.2 1.4 0.2 0.7 0 1.5-0.2 2.1-0.4-3.5-0.7-6.1-3.7-6.1-7.4v-0.1c1 0.6 2.2 1 3.4 1-2-1.3-3.3-3.7-3.3-6.3 0-1.4 0.4-2.7 1-3.8 3.7 4.6 9.3 7.6 15.5 7.9-0.1-0.5-0.1-1.1-0.1-1.7 0-4.2 3.3-7.6 7.5-7.6 2.2 0 4.1 0.9 5.5 2.4 1.7-0.3 3.4-1 4.9-1.9-0.6 1.8-1.8 3.3-3.4 4.3 1.6-0.2 3-0.6 4.4-1.2z m-4.6 2.9c0.3-0.2 0.7-0.5 0.9-0.6-0.2 0-0.9 0.1-1.5 0s-1.6-0.4-1.6-0.4 1.1-1 1.4-1.3l0.8-0.8c-0.3 0-0.7 0.1-1.1 0.2l-0.6 0.1-0.4-0.4c-1.2-1.3-2.9-2.1-4.7-2.1-3.5 0-6.3 2.9-6.3 6.4 0 0.4 0.1 0.9 0.2 1.4l0.4 1.6-1.8-0.1c-3.2-0.1-6.3-1-9.2-2.5-2.2-1-4.1-2.6-5.8-4.3-0.1 0.4-0.2 1-0.2 1.5 0 2.1 1.1 4.1 2.8 5.3 0 0 2.6 1.8 3.6 2.2-1.9 0.2-4.4 0-4.4 0-0.6 0-1.2 0-1.8-0.2 0.6 2.2 2.5 3.9 4.8 4.4l4.8 0.8-4.8 1.6c-0.5 0.2-1.1 0.2-1.6 0.2 1.1 1.6 2.9 2.7 5 2.7l3.5 0.1-2.7 2.2c-1.5 1-3 1.9-4.7 2.5-0.8 0.3-1.5 0.5-2.3 0.7 2.1 0.7 4.3 1.1 6.6 1.1 3.1 0 6.1-0.7 8.7-1.9 2.4-1.1 4.5-2.7 6.3-4.7 1.8-1.9 3-4.2 3.9-6.6 0.9-2.3 1.4-4.8 1.4-7.2v-0.9l-0.1-0.6z' })
        )
    );
};

exports.default = IoSocialTwitterOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-twitter-outline.js
// module id = 2507
// module chunks = 0